import { Injectable } from "@angular/core";
import { Database } from './../database';
import 'rxjs/add/operator/map';
import { NL_StokKarti } from "../../models/NL_StokKarti";


@Injectable()
export class BllStoklar extends Database {
  eklenecek_stokkartlari = [];

  constructor() {
    super("NL_StokKarti");
  }

  FiyatlariGuncelle(stok: NL_StokKarti) {
    return new Promise((res, err) => {
      this.execRawQueryWithParams("update NL_StokKarti set Price1 = ? where ID = ?", [stok.Price1, stok.ID]).then(a => {
        res(a);
      });
      this.execRawQueryWithParams("update NL_StokKarti set Price2 = ? where ID = ?", [stok.Price2, stok.ID]).then(a => {
        res(a);
      });
      this.execRawQueryWithParams("update NL_StokKarti set Price3 = ? where ID = ?", [stok.Price3, stok.ID]).then(a => {
        res(a);
      });
      this.execRawQueryWithParams("update NL_StokKarti set Price4 = ? where ID = ?", [stok.Price4, stok.ID]).then(a => {
        res(a);
      });

    })
  }
  StokKartiEkle(ID: number, Kodu: string, StokAdi: string, Barcode1: string, Barcode2: string, Vat: number, KategoriID: number, MarkId: number,
    VatGrupId: number, Price1: number, Price2: number, Price3: number, Price4: number, BirimId: number,
    IsTerazi: number, PLU: number, MaximumSeviye: number, MinumumSeviye: number, YerliMi: number, UlkeID: number,Status:number,WebStatus:number,ParentAktif:number
    ,DolarFiyat:number
    ,DovizTipi:number,DovizSimge:string) {
    return new Promise((resolve, reject) => {
      var kart = new NL_StokKarti();
      
      kart.ID = ID;
      kart.Kodu = Kodu;
      kart.StokAdi = StokAdi;
      kart.Barcode1 = Barcode1;
      kart.Barcode2 = Barcode2;
      kart.Vat = Vat;
      kart.KategoriID = KategoriID;
      kart.MarkId = MarkId;
      kart.VatGrupId = VatGrupId;
      kart.Price1 = Price1;
      kart.Price2 = Price2;
      kart.Price3 = Price3;
      kart.Price4 = Price4;
      kart.Status = Status;
      kart.WebStatus =WebStatus;
      kart.BirimId = BirimId;
      kart.IsTerazi = IsTerazi;
      kart.PLU = PLU;
      kart.MaximumSeviye = MaximumSeviye;
      kart.MinumumSeviye = MinumumSeviye;
      kart.YerliMi = YerliMi;
      kart.UlkeID = UlkeID;
      kart.ParentAktif=ParentAktif;
      kart.DolarFiyat=DolarFiyat;
      kart.DovizTipi=DovizTipi;
      kart.DovizSimge=DovizSimge;
      
      
      this.add(kart).then(a => {
        resolve(a);
      }).catch(x => {
        reject(x);
      })
    });
  }
}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-stoklar.ts